<template>
  <div
    class="national-winners-wrapper"
    :class="siteVariant"
  >
    <IntroTitle :site-variant="siteVariant">
      <div class="congrats">
        <h2>
          Congratulations National Finalists!
        </h2>
        <p>
          The National Finalists for the 2025 {{
            siteVariant.charAt(0).toUpperCase() + siteVariant.slice(1)
          }} Storytelling Competition competed for top honors in Las Vegas
          on June {{ siteVariant === 'acura' ? '17th' : '19th' }}!
        </p>
        <p>
          Our Finalists shared thousands of dollars in cash prizes and {{
            siteVariant === 'acura' ? 'COSE' : 'COSL'
          }} Sales Credits* – please help us congratulate:
        </p>
      </div>
    </IntroTitle>
    <section class="winners">
      <TheLoading v-if="loadingNational" />
      <div
        v-else
        class="wrapper"
      >
        <NationalWinnersCards :winners="nationalWinners"/>
        <FinalistCards
          title="Remaining Finalists"
          :finalists="zoneWinners"
          layout="list"
        />
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import IntroTitle from '@/components/intro/IntroTitle.vue';
import NationalWinnersCards from '@/components/NationalWinnersCards.vue';
import FinalistCards from '@/components/FinalistCards.vue';
import { useToast } from 'vue-toastification';
import api from '@/api';
import TheLoading from '@/components/TheLoading.vue';
import { useMeta } from 'vue-meta';

const props = defineProps({
  siteVariant: String,
});

const toast = useToast();

const loadingNational = ref(false);
const nationalWinners = ref([]);

const zoneWinners = ref([]);

useMeta({
  description: 'My awesome site',
});

const fetchNationalResults = async () => {
  loadingNational.value = true;
  try {
    const { data } = await api.data.getNationalWinners(props.siteVariant);
    nationalWinners.value = data.slice(0, 4);
    zoneWinners.value = data.slice(4);
  } catch {
    toast.error('An error ocurred while fetching national finalists. Please try again.');
  } finally {
    loadingNational.value = false;
  }
};

onMounted(() => {
  fetchNationalResults();
});
</script>

<style scoped lang="scss">
.national-winners-wrapper {
  margin-bottom: 45px;
  position: relative;
  z-index: 1;

  .intro-title {
    @media (min-width: 641px) {
      position: relative;
      padding-bottom: 0;
    }
  }
}

.congrats {
  padding: 20px 0 30px;
  color: $AC_White;
  max-width: 1640px;
  margin: 0 auto;
  position: relative;
  z-index: 1;

  @media (min-width: 641px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media (min-width: 1025px) {
    padding-top: 40px;
    padding-bottom: 50px;
  }

  h2 {
    font-size: clamp(30px, 84px, 5.45vw);
    letter-spacing: 0.75px;
    line-height: 1;
    text-transform: uppercase;
    margin-bottom: 20px;
  }

  p {
    font-size: clamp(22px, 50px, 2.65vw);
    letter-spacing: 0.5px;
    line-height: 1.4;
  }

  p:not(:last-child) {
    margin-bottom: 30px;
  }
}

.winners {
  padding: 15px;

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 45px;
    max-width: 1550px;
    margin: 0 auto;

    @media (min-width: 1281px) {
      gap: 60px;
    }

    @media (min-width: 1500px) {
      border: 2px solid $AC_Orange;
      border-radius: 10px;
      box-shadow: 0 0 20px $AC_Orange;
      padding: 75px 0;
    }
  }
}

.acura {
  .congrats {
    h2 {
      font-family: 'Avenir Heavy';
    }

    p {
      font-family: 'Avenir';
      font-weight: 300;
    }
  }
}

.honda {
  .congrats {
    h2 {
      font-family: 'Myriad Pro';
      font-weight: 700;
    }

    p {
      font-family: 'Myriad Pro';
      font-weight: 300;
    }
  }
}
</style>
